// extracted by mini-css-extract-plugin
export default {"carousel":"Suggestions_carousel__eG2uY","tags":"Suggestions_tags__jPx6b","city":"Suggestions_city__KE1Yl","category":"Suggestions_category__w0sW0","image":"Suggestions_image__i3u6p"};